module.exports = __webpack_public_path__ + "static/media/our-readers-img.9d553b94.svg";